// src/services/notificationLinks.js
import { API_BASE_SOBEVENDA } from "./api";
import { PLATFORM_NOTIFICATION_PARAMS } from "../utils/platformNotificationTemplates";

// Recupera o token do localStorage
function getAuthHeaders() {
  const token = localStorage.getItem("sobevenda_token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
}

export function getPlatformNotificationUrl(platform) {
  if (!platform) return "";
  const template = PLATFORM_NOTIFICATION_PARAMS[platform];
  return template?.url || "";
}

export async function getNotificationLinks() {
  const res = await fetch(`${API_BASE_SOBEVENDA}/notification_links`, {
    method: "GET",
    headers: getAuthHeaders(),
  });
  if (!res.ok) {
    console.error("Xano fetch error:", await res.text());
    throw new Error("Falha ao buscar links de notificação");
  }
  return await res.json();
}

/**
 * Cria um link de notificação.
 * Envia secret_key e params quando existirem.
 */
export async function createNotificationLink({ platform, name, params, secret_key }) {
  const body = {
    platform,
    name,
    ...(params ? { params } : {}),
    ...(secret_key ? { secret_key } : {}),
  };

  const res = await fetch(`${API_BASE_SOBEVENDA}/notification_links`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });

  if (!res.ok) {
    console.error("Create link error:", await res.text());
    throw new Error("Falha ao criar o link de notificação");
  }

  return await res.json(); // esperado: objeto com url/params/etc.
}

/**
 * Atualiza um link de notificação.
 * Só envia os campos presentes (não sobrescreve secret_key com vazio).
 */
export async function updateNotificationLink(
  id,
  { platform, name, params, secret_key }
) {
  const body = {
    ...(platform ? { platform } : {}),
    ...(name ? { name } : {}),
    ...(params ? { params } : {}),
    ...(secret_key ? { secret_key } : {}), // só manda se usuário digitou nova secret
  };

  const res = await fetch(
    `${API_BASE_SOBEVENDA}/notification_links/${parseInt(id, 10)}`,
    {
      method: "PATCH",
      headers: getAuthHeaders(),
      body: JSON.stringify(body),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("Xano update error:", text);
    throw new Error("Falha ao atualizar link");
  }

  // Alguns endpoints retornam o objeto inteiro; outros envolvem em { notification_links }
  const data = await res.json();
  return data.notification_links ? data.notification_links : data;
}

export async function deleteNotificationLink(id) {
  const res = await fetch(
    `${API_BASE_SOBEVENDA}/notification_links/${parseInt(id, 10)}`,
    {
      method: "DELETE",
      headers: getAuthHeaders(),
    }
  );

  if (!res.ok) {
    const text = await res.text();
    console.error("Xano delete error:", text);
    throw new Error(`Falha ao excluir link: ${res.status}`);
  }

  return true;
}
